"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));
function _interopRequireWildcard(e, t) { if ("function" == typeof _WeakMap) var r = new _WeakMap(), n = new _WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && _Object$getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var _default = exports.default = {
  components: {
    AwayStatusIndicator: _AwayStatusIndicator.default,
    UserAvatar: _UserAvatar.default
  },
  props: ['network'],
  data: function data() {
    return {
      is_usermenu_open: false
    };
  },
  computed: {
    networkName: function networkName() {
      var name = TextFormatting.t('no_network');
      if (this.network) {
        name = this.network.name;
      }
      return name;
    },
    getUser: function getUser() {
      if (this.network && this.network.state && this.network.currentUser()) {
        return this.network.currentUser();
      }
      return null;
    },
    isConnected: function isConnected() {
      return this.network && this.network.state === 'connected';
    }
  },
  methods: {
    showUserBox: function showUserBox() {
      // if on mobile narrow device
      var kiwiState = this.$state;
      if (kiwiState.ui.is_narrow) {
        kiwiState.$emit('statebrowser.hide');
      }
      var user = this.$state.getActiveNetwork().currentUser();
      this.$state.$emit('userbox.show', user);
    },
    clickForget: function clickForget() {
      var msg = 'This will delete all stored networks and start fresh. Are you sure?';
      // eslint-disable-next-line no-restricted-globals, no-alert
      var confirmed = confirm(msg);
      if (!confirmed) {
        return;
      }
      this.$state.persistence.forgetState();
      window.location.reload();
    }
  }
};